import { version } from "../../../../apps/wayup-web/package.json";

export const useAppVersion = () => {
  return version;
};
